import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Role } from '../../../identite/shared/classes/role';
import { fadeInOut, focusInOut } from '../../classes/animations';
import { SearchRoleByNameComponent } from '../search-role-by-name/search-role-by-name.component';

@Component({
  selector: 'app-search-role-or-create',
  templateUrl: './search-role-or-create.component.html',
  styleUrls: ['./search-role-or-create.component.css'],
  animations: [fadeInOut, focusInOut]
})
export class SearchRoleOrCreateComponent implements OnInit {
  @Input()  aclRoleId: string;
  @Input()  aclLabel: string;
  @Input()  toolTips: string;

  @ViewChild('search') search: ElementRef<SearchRoleByNameComponent>;
  public    showNewClient = false;
  public    newRole = new Role();

  @Output() selectedRoleCallback = new EventEmitter<Role>();

  constructor() { }

  ngOnInit() {
    this.newRole.acl_roles_id = this.aclRoleId;
  }

  toggleNew() {
    this.showNewClient = !this.showNewClient;
  }

  onSelectedRoleEvent(role: Role) {
    if(role){
      this.selectedRoleCallback.emit(role);
    }
  }

  reset(): void {
    this.search.nativeElement.reset();
  }
}
